// extracted by mini-css-extract-plugin
module.exports = {"card":"LoadAssetsCard_card__j8KXe"};